import { cn } from 'cn';
import { Loader2 } from 'lucide-react';

export function Spinner({ className, label = 'Loading' }: { className?: string; label?: string }) {
  return (
    <span role="status" className="inline-flex items-center">
      <Loader2
        aria-hidden="true"
        className={cn('size-5 animate-spin text-muted-foreground', className)}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function FullPageSpinner() {
  return (
    <div className="grid min-h-dvh place-items-center">
      <Spinner className="size-7 text-brand-600" />
    </div>
  );
}
